module.exports = __webpack_public_path__ + "img/phone.4586a1e3.svg";